(function () {
    "use strict";

    angular.module("trakeyeApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("config", {
                parent: "entity",
                url: "/config?page&sort&search",
                data: {
                    authorities: ['ROLE_SUPER_ADMIN'],
                    pageTitle: "trakeyeApp.workFlow.home.title",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/config/configs.html",
                        controller: "ConfigController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    size: {
                        value: "10",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ]
                },
            })
            .state("config.new", {
                url: "/config",
                data: {
                    authorities: ['ROLE_SUPER_ADMIN'],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/config/config-dialog.html",
                        controller: "ConfigDialogController",
                        controllerAs: "vm",
                    },
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "PaginationUtil",
                        function () {
                            return {
                                configCategoryName: null,
                                configKey: null,
                                configValue: null,
                                createdBy:  null,
                                createdDate:  null,
                            };
                        },
                    ],
                },
            })
            
            .state('config.edit', {
                parent: 'config',
                url: '/Edit/{id}',
                data: {
                    authorities: ['ROLE_SUPER_ADMIN'],
                    pageTitle: 'trakeyeApp.material.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl:
                            "app/entities/config/config-dialog.html",
                        controller: 'ConfigDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'Configs', function ($stateParams, Configs) {
                        return Configs.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'config',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
    }
})();
